import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {Criterion} from "./criterionDomain";

@entityConfig()
export class CriterionScore extends DomainAncestor {

  @observable scoreId: number;
  @observable fromValue: number;
  @observable toValue: number;
  @observable score: number;
  @observable criterion : Criterion

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.scoreId;
  }

  public setId(id: ID): void {
    this.scoreId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/criterion/criterionScoreDomain.ts